export enum TypeResponse {
  PUBLICATIONS,
  OPERATIONALS,
}
